import { Star } from "lucide-react";
import { useEffect, useState } from "react";
import { SectionTitle } from "../../components/common/SectionTitle";
import { reviews } from "../../data/siteData";

export function ReviewsSection() {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const interval = window.setInterval(() => {
      setActiveIndex((current) => (current + 1) % reviews.length);
    }, 5000);

    return () => window.clearInterval(interval);
  }, []);

  const review = reviews[activeIndex];

  return (
    <section id="reviews" className="site-section">
      <div className="container">
        <SectionTitle subtitle="Testimonials" title="What Our Clients Say" />

        <div className="review-showcase scroll-reveal">
          <div className="rating-row rating-row--center">
            {Array.from({ length: review.rating }).map((_, index) => (
              <Star key={index} size={18} fill="currentColor" />
            ))}
          </div>

          <p className="review-showcase__quote">“{review.text}”</p>
          <p className="review-showcase__author">{review.name}</p>
          <p className="muted">{review.service}</p>

          <div className="dot-nav">
            {reviews.map((item, index) => (
              <button
                key={`${item.name}-${index}`}
                className={index === activeIndex ? "dot-nav__button dot-nav__button--active" : "dot-nav__button"}
                onClick={() => setActiveIndex(index)}
                aria-label={`Show review ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
